<template>
  <div class="body">
    <div>
      <table class="table" cellpadding="0" cellspacing="0">
        <tr>
          <td class="tableLabel">出厂编号：</td>
          <td class="tableModel">{{processExceptionVO.factoryNo}}</td>
          <td class="tableLabel">客户名称：</td>
          <td class="tableModel">{{processExceptionVO.customerName}}</td>
          <td class="tableLabel">处理方式：</td>
          <td class="tableModel">{{processExceptionVO.processMode}}</td>
        </tr>
        <tr>
          <td class="tableLabel">开单人：</td>
          <td class="tableModel">{{processExceptionVO.creatorName}}</td>
          <td class="tableLabel">开单时间：</td>
          <td class="tableModel">{{processExceptionVO.createdTime}}</td>
          <td class="tableLabel">提交时间：</td>
          <td class="tableModel">{{processExceptionVO.submitTime}}</td>
        </tr>
        <tr>
          <!--          <td class="tableLabel">开单部门：</td>-->
          <!--          <td class="tableModel">{{processExceptionVO.department}}</td>-->
          <td class="tableLabel">开单班组：</td>
          <td class="tableModel">{{processExceptionVO.team}}</td>
          <td class="tableLabel">问题描述：</td>
          <td class="tableModel">{{processExceptionVO.problemDesc}}</td>
        </tr>
        <tr>
          <td class="tableLabel">是否处理：</td>
          <td class="tableModel">{{processExceptionVO.isHandle?"是":"否"}}</td>
          <td class="tableLabel">处理部门接口人：</td>
          <td class="tableModel">{{processExceptionVO.handleName}}</td>
          <td class="tableLabel">质量接口人：</td>
          <td class="tableModel">{{processExceptionVO.qualityDirecterName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">供应商名称：</td>
          <td class="tableModel">{{processExceptionVO.supplierName}}</td>
          <td class="tableLabel">责任部门：</td>
          <td class="tableModel">
            {{processExceptionVO.responsibleDepartment}}
          </td>
          <td class="tableLabel">质量判责结果：</td>
          <td class="tableModel">{{processExceptionVO.judgmentResult}}</td>
        </tr>
      </table>
    </div>
    <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
      <div>
        <el-form
            ref="formUplosd"
            enctype="multipart/form-data"
            label-position="right"
            label-width="120px"
            size="mini">
          <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between">
            <div>
              <div v-if="!processExceptionVO.accessories || !processExceptionVO.accessories.length">暂无附件</div>
              <table width="100%">
                <tr v-for="(item, index) in processExceptionVO.accessories" :key="index">
                  <td>附件{{index + 1}}</td>
                  <td style="cursor: pointer;padding:5px;color: #20a0ff" @click="openFile(item)">{{item.fileName}}</td>
                  <td style="padding:5px"><el-input v-model="item.note" size="mini"/></td>
                  <td style="padding:5px;color: #20a0ff;cursor: pointer;" @click="deleteFile(index)">删除</td>
                </tr>
              </table>
            </div>
            <div>
              <el-upload
                  action=""
                  multiple
                  :http-request="submitUpload"
                  :show-file-list="false"
                  :disabled="uploadLoading"
                  style="display: inline-block; float: right; margin: 5px;">
                <el-button type="primary" plain>
                  <i class="el-icon-upload el-icon--right"/>
                  附件上传
                </el-button>
              </el-upload>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单物料</div>
      <div style="padding: 0 0 10px 10px;margin: 0 auto">
        <el-table :data="processExceptionVO.processExceptionMaterialVOS">
          <el-table-column label="物料编号" align="center" prop="materialNo"/>
          <el-table-column label="物料描述" align="center" prop="materialName"/>
          <el-table-column label="不良数量" align="center" prop="badNum" width="100"/>
        </el-table>
      </div>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import constants from "@/util/constants";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "",
    components: {HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        constants,
        activeName: "first",
        uploadLoading:false,
        processExceptionVO: {
          processExceptionMaterialVOS: [],
          accessories: [],
        },

      };
    },
    watch: {
      params: {
        handler() {
          this.doApprove();
        },
      },
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        console.log(this.params);
        this.$emit("loading-status", {"loading": true});
        this.$http
          .get("basic", `processExceptions/${this.billId}`)
          .then(resp => {
            console.log(resp);
            this.$emit("loading-status", {"loading": false});
            this.processExceptionVO = resp;
          });
      },
      onSelectHandle(row) {
        this.processExceptionVO.handleID = row.systemUserID;
        this.processExceptionVO.handleName = row.employeeName;
      },
      onSelectCountersign(row) {
        this.processExceptionVO.countersignID = row.systemUserID;
        this.processExceptionVO.countersignName = row.employeeName;
      },
      onSelectRework(row) {
        this.processExceptionVO.reworkID = row.systemUserID;
        this.processExceptionVO.reworkName = row.employeeName;
      },
      deleteFile(index) {
        this.processExceptionVO.accessories.splice(index, 1);
      },
      openFile(item) {
        console.log(item);
        let a = document.createElement("a");
        a.href = "http://emes.stepelectric.com" + item.filePath;
        a.target = "_blank";
        a.download = item.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      doApprove() {
        //console.log(this.params.countersignVOS);
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          approveVar: this.params.approveVar,
          billParam: "",
        };
        console.log(this.params);
        // this.sentWeChat(0,"fanghl");
        this.$emit("loading-status", {"loading": true});
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {"loading": false});
            //退回到审批人时状态修改到未提交
            if (this.params.actionType ===2 && this.params.untreadedFlowId === "0;submitter") {
              this.updateStatus();
            }
            if (this.params.actionType ===0 && this.params.nodeId === "DealDepartment") {
              //企业微信通知;
              if (this.params.applicationVarVOS[0].varValue === "特批" && this.params.applicationVarVOS[1].varValue === "true") {
                this.params.applicationVarVOS.forEach(item=>{
                  if (item.varValue === "true" && item.varName === "CountersignComments_ht") {
                    this.sentWeChat(0,"wangtj");
                    setTimeout(1000);
                  }else if (item.varValue === "true" && item.varName === "CountersignComments_ds") {
                    this.sentWeChat(0,"liuyf");
                    setTimeout(1000);
                  }else if (item.varValue === "true" && item.varName === "CountersignComments_bs") {
                    this.sentWeChat(0,"yuyong");
                    setTimeout(1000);
                  }else if (item.varValue === "true" && item.varName === "CountersignComments_cg") {
                    this.sentWeChat(0,"liuym");
                    setTimeout(1000);
                  }else if (item.varValue === "true" && item.varName === "CountersignComments_clg") {
                    this.sentWeChat(0,"cailg");
                    setTimeout(1000);
                  }else if (item.varValue === "true" && item.varName === "CountersignComments_cl") {
                    this.sentWeChat(0,"chenlin");
                  }
                });
              }
            }
            this.$message.success("操作成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/ProcessException",
            });
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.processExceptionVO.accessories.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      updateStatus() {
        this.$http
          .get("basic", `processExceptions/updateStatus/${this.processExceptionVO.pkid}`)
          .then(() => {
            this.$message.success("退回到提交人成功！！！");
          });
      },
      sentMessage() {
        let name = "";
        let userId = 0;
        switch (this.params.nodeId) {
          case "DealDepartment":
            console.log("sentMessagesentMessagesentMessagesentMessage");
            console.log(this.params.applicationVarVOS);
            if (this.params.applicationVarVOS.length>0) {
              if (this.params.applicationVarVOS[0].varValue === "特批" && this.params.applicationVarVOS[1].varValue === "true") {
                this.sentWeChat(0,"fanghl");
                // if (this.params.applicationVarVOS[2].varValue === "true") {
                //   // this.sentWeChat(0,"wangtj");
                //   this.sentWeChat(0,"fanghl");
                // }
                // if (this.params.applicationVarVOS[3].varValue === "true") {
                //   // this.sentWeChat(0,"liuyf");
                //   this.sentWeChat(0,"fanghl");
                // }
                // if (this.params.applicationVarVOS[4].varValue === "true") {
                //   // this.sentWeChat(0,"yuyong");
                //   this.sentWeChat(0,"fanghl");
                // }
                // if (this.params.applicationVarVOS[5].varValue === "true") {
                //   // this.sentWeChat(0,"liuym");
                //   this.sentWeChat(0,"fanghl");
                // }
                // if (this.params.applicationVarVOS[6].varValue === "true") {
                //   // this.sentWeChat(0,"cailg");
                //   this.sentWeChat(0,"fanghl");
                // }
              }

            }
            break;
          case "CountersignComments_ht":
            console.log(this.params.applicationVarVOS);
            break;
          case "CountersignComments_ds":
            console.log(this.params.applicationVarVOS);
            break;
          case "CountersignComments_bs":
            console.log(this.params.applicationVarVOS);
            break;
          case "CountersignComments_cg":
            console.log(this.params.applicationVarVOS);
            break;
          case "CountersignComments_clg":
            console.log(this.params.applicationVarVOS);
            break;
          case "Managerriskassessment":
            break;
        }
      },
      sentWeChat(userId,name) {
        let params = {
          userId:userId,
          name:name,
          pkid:this.processExceptionVO.pkid,
          formId:24,
        };
        console.log(params);
        this.$http
          .get("basic", "inspectionInComings/sentWeChat",params)
          .then(() => {
          });
      },
    },
  };
</script>
<style lang="scss">
  .body {
    .table {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;

      .tableLabel {
        width: 130px;
        padding: 1%;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }

      .tableModel {
        width: 20%;
        padding: 1%;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }
    }
  }
</style>
